import * as React from "react";

export type SidebarContextValue = {
  state: "expanded" | "collapsed";
  open: boolean;
  setOpen: (open: boolean) => void;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  isMobile: boolean;
  toggleSidebar: () => void;
};

const SIDEBAR_CONTEXT_GLOBAL_KEY = "__NFP_TRACKER_SIDEBAR_CONTEXT__";

const globalSidebarContextStore = globalThis as typeof globalThis & {
  [SIDEBAR_CONTEXT_GLOBAL_KEY]?: React.Context<SidebarContextValue | null>;
};

export const SidebarContext =
  globalSidebarContextStore[SIDEBAR_CONTEXT_GLOBAL_KEY] ??
  React.createContext<SidebarContextValue | null>(null);

globalSidebarContextStore[SIDEBAR_CONTEXT_GLOBAL_KEY] = SidebarContext;

export const useSidebar = () => {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider.");
  }

  return context;
};
